import './IntercomChat.scss';
import React, {useEffect, useState} from 'react';
const baseClassName = 'intercom-chat';

export default function IntercomChat({className, ...props}) {
    return <div className={baseClassName}></div>
}